import React from 'react';
import { COLOR } from '@latitude/core/utils/constants';
import { Svg } from './Chevron.styles';

var Chevron = function Chevron(_ref) {
  var _ref$ariaHidden = _ref.ariaHidden,
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? COLOR.BLACK : _ref$color,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'up' : _ref$direction;
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": "arrow " + direction + " icon",
    "aria-hidden": ariaHidden
  }, /*#__PURE__*/React.createElement(Svg, {
    color: color,
    direction: direction
  }));
};

export default Chevron;